import axios from 'axios'

// ----------------------------------------------------------------------

const axiosInstance = axios.create()

// API tokens expire (12 hours idle, 7 days at most) and are revoked on a password
// change. When the server rejects the token (401, never 403, which is a permission
// answer), the session is over: drop the token and go to the sign-in page, instead
// of leaving every request on the page failing.
const LOGIN_PATH = '/auth/login'

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const sentToken = Boolean(error?.config?.headers?.Authorization)
    if (error?.response?.status === 401 && sentToken) {
      localStorage.removeItem('accessToken')
      delete axiosInstance.defaults.headers.common.Authorization
      if (!window.location.pathname.startsWith(LOGIN_PATH)) {
        window.location.assign(LOGIN_PATH)
      }
    }
    return Promise.reject(error)
  },
)

export default axiosInstance
